import { render } from "./HeaderTop.vue?vue&type=template&id=39178b56"
import script from "./HeaderTop.vue?vue&type=script&lang=js"
export * from "./HeaderTop.vue?vue&type=script&lang=js"
script.render = render

export default script